"use client";

import { Card } from "react-bootstrap";
import { getOrderStatusLabel } from "../../../utils/getOrderStatusLabel";

interface TrackingIDProps {
  order: any;
}

const TrackingID = ({ order }: TrackingIDProps) => {
  return (
    <>
      <Card className="bg-primary border-0 rounded-3 mb-4 z-0">
        <Card.Body className="p-4">
          {order.shipping?.tracking &&( <h3 className="text-white mb-lg-4 mb-3">Seguimiento: {order.shipping?.tracking }</h3>)}
          <div className="d-flex justify-content-between tracking-step flex-wrap gap-3">
            <div>
              <span className={`text-white fw-semibold count text-center mb-3 ${order?.status === 'CREATED' || order?.status === 'PAID' || order?.status === 'PROCESSING' || order?.status === 'SHIPPED' || order?.status === 'DELIVERED' || order?.status === 'PENDING_APPROVAL' ? 'active' : ''}`}>
                01
              </span>
              <span className="d-block text-white fw-semibold">
                {getOrderStatusLabel(order?.status) }
              </span>
            </div>

            <div className="text-center">
              <span className={`text-white fw-semibold count mb-3 ${order?.status === 'PAID' || order?.status === 'PROCESSING' || order?.status === 'SHIPPED' || order?.status === 'DELIVERED' ? 'active' : ''}`}>02</span>
              <span className="d-block text-white fw-semibold">Pagada</span>
            </div>

            <div className="text-center">
              <span className={`text-white fw-semibold count mb-3 ${order?.status === 'PROCESSING' || order?.status === 'SHIPPED' || order?.status === 'DELIVERED' ? 'active' : ''}`}>
                03
              </span>
              <span className="d-block text-white fw-semibold">Procesando</span>
            </div>

            <div className="text-center">
              <span className={`text-white fw-semibold count mb-3 ${order?.status === 'SHIPPED' || order?.status === 'DELIVERED' ? 'active' : ''}`}>
                04
              </span>
              <span className="d-block text-white fw-semibold">Enviada</span>
            </div>

            <div className="text-end">
              <span className={`text-white fw-semibold count text-center mb-3 ${order?.status === 'DELIVERED' ? 'active' : ''}`}>
                05
              </span>
              <span className="d-block text-white fw-semibold">Entregada</span>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default TrackingID;
